module.exports = __webpack_public_path__ + "assets/img/hero.ce825c49.jpg";